import { render, staticRenderFns } from "./jobList.vue?vue&type=template&id=c9d88bfa&scoped=true"
import script from "./jobList.vue?vue&type=script&lang=ts"
export * from "./jobList.vue?vue&type=script&lang=ts"
import style0 from "./jobList.vue?vue&type=style&index=0&id=c9d88bfa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9d88bfa",
  null
  
)

export default component.exports